<template>
  <RevCard class="p-24 md:px-[6rem] md:py-56">
    <header class="text-center">
      <h1 class="heading-1">{{ i18n(translations.title) }}</h1>
      <p class="body-1 mt-24">
        {{ i18n(translations.subtitle) }}
      </p>

      <div
        class="m-24 mb-0 flex flex-wrap items-center justify-center md:m-0 md:mt-24"
      >
        <Flag
          v-for="market in potentialMarkets"
          :key="market"
          class="mb-16 ml-0 mr-12 mt-0"
          :country-code="market"
        />
      </div>
    </header>

    <section>
      <RevContentBlock
        :button-label="i18n(translations.learnMore)"
        button-variant="secondary"
        class="mt-56"
        :image-props="backShipImage"
        :surtitle="i18n(translations.backShipSurtitle)"
        :title="i18n(translations.backShipTitle)"
        title-variant="title2"
        :to="WHAT_IS_BACKSHIP_LINK"
      >
        <span class="body-1">
          <FormattedMessage :definition="translations.backShipText">
            <template #intro>
              <span class="body-1-bold">
                {{ i18n(translations.backShipTextIntro) }}
              </span>
            </template>
          </FormattedMessage>
        </span>
      </RevContentBlock>

      <RevContentBlock
        :button-label="i18n(translations.learnMore)"
        button-variant="secondary"
        class="mt-56"
        :image-left="!isSmallScreen"
        :image-props="backCareImage"
        :surtitle="i18n(translations.backCareSurtitle)"
        :title="i18n(translations.backCareTitle)"
        title-variant="title2"
        :to="LEARN_MORE_ABOUT_BACKCARE_LINK"
      >
        <span class="body-1">
          <FormattedMessage :definition="translations.backCareText">
            <template #intro>
              <span class="body-1-bold">
                {{ i18n(translations.backCareTextIntro) }}
              </span>
            </template>
          </FormattedMessage>
        </span>
      </RevContentBlock>
    </section>
  </RevCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { MarketCountryCode } from '@backmarket/http-api'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useClientOnlyComputedBreakpoint } from '@backmarket/utils/composables/useClientOnlyComputedBreakpoint'
import { Breakpoint } from '@backmarket/utils/dom/getCurrentBreakpoint'
import { RevCard } from '@ds/components/Card'
import { RevContentBlock } from '@ds/components/ContentBlock'

import { getExternalLinkList } from '~/constants/externalLinks'

import translations from './EmptyState.translations'

defineProps<{
  potentialMarkets: MarketCountryCode[]
}>()

const i18n = useI18n()
const breakpoint = useClientOnlyComputedBreakpoint()

const isSmallScreen = computed(() => breakpoint.value < Breakpoint.LG)

const { LEARN_MORE_ABOUT_BACKCARE_LINK, WHAT_IS_BACKSHIP_LINK } =
  getExternalLinkList(i18n.currentLocale)

const backShipImage = {
  alt: '',
  height: 257,
  src: '/img/options/markets/shipping.svg',
  width: 465,
}

const backCareImage = {
  alt: '',
  height: 257,
  src: '/img/options/markets/customer-care.svg',
  width: 465,
}
</script>
